<template>
    <div class="app">
        <scroll @refresh="refresh">
            <section class="agreemment-content" v-html="agreement">
            </section>
        </scroll>
    </div>
</template>
<script>
    export default {
        methods: {
            refresh() {
                this.$http.get('/app/common/agreement').then(res => {
                    if (res.data.resultCode === this.constant.RESULT_SUCCESS) {
                        this.agreement = res.data.data.agreement;
                    }
                })
            }
        },
        mounted() {
            this.refresh();
        },
        data() {
            return {
                agreement: ''
            }
        }
    }
</script>




// WEBPACK FOOTER //
// Agreement.vue?310167c6